import { render, staticRenderFns } from "./headerComponent.vue?vue&type=template&id=473cdf74"
import script from "./headerComponent.vue?vue&type=script&lang=js"
export * from "./headerComponent.vue?vue&type=script&lang=js"
import style0 from "./headerComponent.vue?vue&type=style&index=0&id=473cdf74&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports